<script lang="ts" setup>
const DefaultLayoutWithVerticalNav = defineAsyncComponent(() => import('./components/DefaultLayoutWithVerticalNav.vue'))

const { layoutAttrs, injectSkinClasses } = useSkins()

injectSkinClasses()
</script>

<template>
  <ClientOnly fallback-tag="div">
    <DefaultLayoutWithVerticalNav v-bind="layoutAttrs">
      <slot />
    </DefaultLayoutWithVerticalNav>
    <template #fallback>
      <div
        class="d-flex align-center justify-center"
        style="min-block-size: 100vh;"
      >
        <VProgressCircular
          indeterminate
          color="primary"
          size="64"
        />
      </div>
    </template>
  </ClientOnly>
</template>

<style lang="scss">
// As we are using `layouts` plugin we need its styles to be imported
@use "@layouts/styles/default-layout";
</style>
